
export const price_display_template = [
'<div class="d-flex gap-1"',
'   <p class="mb-0">from</p>',
'   <strong>${{ price }}</strong>',
'   <p class="mb-0">/night</p>',
'</div>',
].join("\n");